module.exports = __webpack_public_path__ + "img/mindwave.ceed03db.png";